import { useState, useRef, useEffect } from "react";

const HelpTooltip = ({ text }: any) => {
  const [visible, setVisible] = useState(false);
  const tipRef = useRef<any>(null);
  const iconRef = useRef<any>(null);

  useEffect(() => {
    if (!visible || !tipRef.current || !iconRef.current) return;
    const iconRect = iconRef.current.getBoundingClientRect();
    const tip = tipRef.current;
    const tipRect = tip.getBoundingClientRect();
    if (iconRect.right + tipRect.width + 8 > window.innerWidth) {
      tip.style.left = "auto";
      tip.style.right = "calc(100% + 6px)";
    }
  }, [visible]);

  return (
    <span
      className="wc-help-tooltip-wrapper"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <i className="bi bi-question-circle wc-help-icon" ref={iconRef} />
      {visible && (
        <span className="wc-help-tooltip" ref={tipRef}>
          {text}
        </span>
      )}
    </span>
  );
};

export default HelpTooltip;
